<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Process NDR</li>
    </ol>
  </nav>
  <div class="row align-items-center">
    <div class="col-12 mt-md-0 text-right float-right">
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right">
        <a class="dropdown-item file btn shift-import" (click)="openPopupNewLocation()">Delivers at new location</a>
        <a class="dropdown-item file btn shift-import">Raise RTO</a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th>

            </th>
            <th>Order#</th>
            <th>Customer</th>
            <th>Reason</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of ordersData.invoiceData">
            <td>
              <div class="form-checkbox">
                <input type="checkbox" id="{{o.id}}" [(ngModel)]="o.isSelected" name="list_name">
                <label for="{{o.id}}"></label></div>
            </td>
            <td>{{o.orderNumber}}</td>
            <td>{{o.customerName}}</td>
            <td>{{o.reason}}</td>
            <td>
              <button type="submit" class="btn btn-orange ml-2" (click)="ReattemptRequestPopupOpen()">Reattempt</button>
              <button type="submit" class="btn btn-orange ml-2" (click)="needActionPopupOpen()">Request RTO</button>
              <button type="submit" class="btn btn-orange ml-2" (click)="openEscalatePopup()">Escalate</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- Modal -->

<div [ngStyle]="{'display': needActionPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': needActionPopup == 'Y'}" class="modal" id="needActionPopUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="needActionLabe">Return to Order</h5>
        <button type="button" class="close" (click)="closeNeedActionPopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <label class="control-label" for="cancelReason">Reason</label>
              <select id="cancelReason" class="form-control" [(ngModel)]="needActionReason"
                      [ngModelOptions]="{standalone: true}" required>
                <option *ngFor="let c of actionReasons" [ngValue]="c.config">{{c.label}}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label" for="description">Notes</label>
              <textarea id="description" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeNeedActionPopUp()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1">Request RTO</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div [ngStyle]="{'display': ReattemptRequestPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': ReattemptRequestPopup == 'Y'}" class="modal" id="ReattemptRequestPopup" tabindex="-1"
     role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="ReattemptRequest">Reattempt Request</h5>
        <button type="button" class="close" (click)="closeReattemptRequestPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Customer Details</b></h2>
                <div class="row mt-3">
                  <div class="col-lg-4 col-sm-6">
                    <label class="text-black">{{viewCustomer?.ownerName | titlecase}}</label>
                    <label class="text-black">{{viewCustomer?.email}}</label>
                    <label class="text-black">{{viewCustomer?.mobile}}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngFor="let add of viewCustomer.adddressList">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Current Address & Delivery</b></h2>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label class="text-black">{{add.addressType | titlecase}}</label><br>
                    <label class="text-black">{{add.address1}}</label><br>
                    <label class="text-black">{{add.address2}}</label><br>
                    <label class="text-black">{{add.city}}</label><br>
                    <label class="text-black">{{add.state}}</label><br>
                    <label class="text-black">{{add.zip}}</label><br>
                    <label class="text-black"><b>Date</b> : 25-10-2021</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <div class="row">
                  <div class="col-6">
                    <div class="form-radio">
                      <input type="radio" id="Notes" [(ngModel)]="reattemptRadioButton " (click)="clear()"
                             [ngModelOptions]="{standalone: true}" required
                             value="Notes" name="type">
                      <label for="Notes">Notes</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-radio">
                      <input type="radio" id="newDelivery" [(ngModel)]="reattemptRadioButton" (click)="clear()"
                             [ngModelOptions]="{standalone: true}" required
                             value="New Delivery" name="type">
                      <label for="newDelivery">New Delivery</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row mt-3" *ngIf="reattemptRadioButton === 'Notes'">
                      <div class="col-4">
                        <textarea id="descriptionR" [(ngModel)]="actionInstructions" class="form-control textbox"
                                  rows="6"
                                  [ngModelOptions]="{standalone: true}" required></textarea>
                      </div>
                    </div>
                    <div class="row mt-3" *ngIf="reattemptRadioButton === 'New Delivery'">
                      <div class="col-4">
                        <div class="form-group ">
                          <label class="control-label" for="address12">Address 1</label>
                          <input type="text" id="address12" class="form-control" required>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group ">
                          <label class="control-label" for="city1">City</label>
                          <input type="text" id="city1" class="form-control" required>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group ">
                          <label class="control-label" for="state">State</label>
                          <input type="text" id="state" class="form-control" required>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group ">
                          <label class="control-label" for="zip">Zip</label>
                          <input type="text" id="zip" class="form-control" required>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group ">
                          <label class="control-label" for="address11">Address 1</label>
                          <input type="text" id="address11" class="form-control" required>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeReattemptRequestPopup()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1">Request</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': escalatePopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': escalatePopup == 'Y'}" class="modal" id="escalatePopup" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="escalatePopupTitle">Escalate</h5>
        <button type="button" class="close" (click)="closeEscalatePopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label">Notes</label>
              <textarea id="descriptionE" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closeEscalatePopup()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1">Escalate</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': deliveryAtNewLocationPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': deliveryAtNewLocationPopup == 'Y'}" class="modal" id="deliveryAtNewLocationPopup"
     tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="deliveryAtNewLocationPopup2">Reattempt Request</h5>
        <button type="button" class="close" (click)="closePopupNewLocation()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Customer Details</b></h2>
                <div class="row mt-3">
                  <div class="col-lg-4 col-sm-6">
                    <label class="text-black">{{viewCustomer?.ownerName | titlecase}}</label>
                    <label class="text-black">{{viewCustomer?.email}}</label>
                    <label class="text-black">{{viewCustomer?.mobile}}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngFor="let add of viewCustomer.adddressList">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Current Address & Delivery</b></h2>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label class="text-black">{{add.addressType | titlecase}}</label><br>
                    <label class="text-black">{{add.address1}}</label><br>
                    <label class="text-black">{{add.address2}}</label><br>
                    <label class="text-black">{{add.city}}</label><br>
                    <label class="text-black">{{add.state}}</label><br>
                    <label class="text-black">{{add.zip}}</label><br>
                    <label class="text-black"><b>Date</b> : 25-10-2021</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <label class="control-label">Notes</label>
              <textarea id="descriptionRr" [(ngModel)]="actionInstructions" class="form-control textbox"
                        rows="6"
                        [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black mb-3">Create New Address</h2>
<!--
                <div class="row">
                  <div class="col-md-4 required">
                    <label class="control-label" for="addressType">Address Type</label>
                    <div class="form-group">
                      <select id="addressType" class="form-control" (blur)="selectAddressType()"
                              [ngClass]="{'is-invalid':statusText6}" [(ngModel)]="addressType"
                              [ngModelOptions]="{standalone: true}" required>
                        <option *ngFor="let a of addressTypes"
                                [ngValue]="a.config">{{a.config | replaceStatus}}</option>
                      </select>
                      <div id="statusText6" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!statusText6">{{statusText6}}</div>
                    </div>
                  </div>
                </div>
-->
                <div class="row">
                  <div class="col-md-4 required">
                    <label class="control-label" for="address1">Address 1</label>
                    <div class="form-group ">
                      <input type="text" id="address1" [(ngModel)]="address1" class="form-control"
                             (blur)="typeAddress1()" [ngClass]="{'is-invalid':statusText1}"
                             [ngModelOptions]="{standalone: true}" required>
                      <div id="statusText1" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!statusText1">{{statusText1}}</div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="control-label" for="address2">Address 2</label>
                    <div class="form-group">
                      <input type="text" id="address2" [(ngModel)]="address2" class="form-control"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4 required">
                    <label class="control-label">City</label>
                    <div class="form-group ">
                      <ng-select type="text" id="city" [(ngModel)]="city" class="form-control" (blur)="typeCity()"
                                 [ngClass]="{'is-invalid':statusText3}" [items]="citiesList" [addTag]="true"
                                 [ngModelOptions]="{standalone: true}"
                                 required>
                      </ng-select>
                      <div id="statusText3" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!statusText3">{{statusText3}}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 required">
                    <label class="control-label">State</label>
                    <div class="form-group">
                      <ng-select id="State" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                                 [ngClass]="{'service-error':statusText4}"
                                 (blur)="typeState()"
                                 [ngClass]="{'is-invalid':statusText4}"
                                 [items]="statesList"
                                 placeholder="State">
                      </ng-select>

                      <div id="statusText4" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!statusText4">{{statusText4}}</div>
                    </div>
                  </div>
                  <div class="col-md-4 required">
                    <label class="control-label" for="accountZipAlt">Zip</label>
                    <div class="form-group ">
                      <input type="text" id="accountZipAlt"
                             onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="6"
                             [(ngModel)]="zip" class="form-control" (change)="ChangeCityAndState()"
                             (blur)="typeZip()" [ngClass]="{'is-invalid':statusText5}"
                             [ngModelOptions]="{standalone: true}" required>
                      <div id="statusText5" class="invalid-feedback d-block shift-invalid-login"
                           [hidden]="!statusText5">{{statusText5}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closePopupNewLocation()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1">Request</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
